import { SaveOutlined, UploadOutlined } from '@ant-design/icons';
import ModalTextForm from '@app/components/modal/ModalTextForm';
import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Space, Tabs, InputNumber, Upload } from 'antd';
import type { UploadFile, UploadProps } from 'antd/es/upload/interface';
import viVN from 'antd/lib/date-picker/locale/vi_VN';
import dayjs from 'dayjs';
import { useEffect, useState, useRef } from "react";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import { urlAdmin } from '../../constants';
import { Links } from '../../helpers/Links';
import { dateCommon, validateMessages } from '../../helpers/common';
import { layChanhVPDuyetTongHopDaoTao, layChiTietDangKyDaoTaoNam, layGiamDocDuyetTongHopDaoTao, layPhoCVPDuyetTongHopDaoTao, layPhoGiamDocDuyetTongHopDaoTao, luuDangKyDaoTaoNam } from '../../services/daotao';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import TrangThaiTongHopTag from './TrangThaiTongHopTag';

const ChiTietDotDangKyDaoTao = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [trangThai, setTrangThai] = useState<number>(0);
    const [id, setId] = useState<number>(0);
    const [phoCVP, setPhoCVP] = useState<any>(null);
    const [isTrinhPhoCVP, setIsTrinhPhoCVP] = useState(false);
    const [isTrinhPhoGD, setIsTrinhPhoGD] = useState(false);
    const [phoGD, setPhoGD] = useState<any>(null);
    const [isTrinhCVP, setIsTrinhCVP] = useState(false);
    const [chanhVP, setChanhVP] = useState<any>(null);
    const [isTrinhGD, setIsTrinhGD] = useState(false);
    const [giamDoc, setGiamDoc] = useState<any>(null);
    const [data, setData] = useState<any>({});
    const [openModalLuu, setOpenModalLuu] = useState(false);
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [idsTaiLieuXoa, setIdsTaiLieuXoa] = useState<Array<number>>([]);

    const uploadProps: UploadProps = {
        onRemove: (file) => {
            if (file.uid.includes("tailieu")) {
                var idTaiLieu = parseInt(file.uid.split("tailieu")[0]);
                setIdsTaiLieuXoa(prev => [...prev, idTaiLieu]);
            }
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            const maxSize = 20000000; // 20 MB
            const dinhDangHoTro = [".doc", ".docx", ".pdf", ".xls", ".xlsx", ".png", ".jpg", ".rar", ".zip"];
            const dinhDang = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
            if (!dinhDangHoTro.includes(dinhDang)) {
                toast.warning("Hệ thống chỉ hỗ trợ các định dạng: " + dinhDangHoTro.join(", "));
            } else if (file.size > maxSize) {
                toast.warning('Tệp tin đính kèm không được vượt quá 20MB');
            } else {
                setFileList(prev => [...prev, file]);
            }
            return false;
        },
        fileList,
    };

    const onFinish = (values: any) => {
        if (!isTrinhPhoCVP && !isTrinhCVP && !isTrinhPhoGD && !isTrinhGD) {
            toast.warning("Vui lòng chọn ít nhất 1 cấu hình người duyệt (Phó CVP, Chánh VP, Phó GĐ hoặc Giám đốc)");
            return;
        }
        var saveData = {
            "id": id,
            "ten": values.ten,
            "nam": values.nam,
            "ngayBatDau": values.ngayBatDau,
            "ngayKetThuc": values.ngayKetThuc,
            "idPhoCVP": isTrinhPhoCVP ? phoCVP?.id : 0,
            "idPhoGiamDoc": isTrinhPhoGD ? phoGD?.id : 0,
            "idChanhVP": isTrinhCVP ? chanhVP?.id : 0,
            "idGiamDoc": isTrinhGD ? giamDoc?.id : 0,
            "kinhPhiDuPhong": values.kinhPhiDuPhong,
            "files": fileList.filter((f: any) => !f.uid?.includes("tailieu")),
            "idsTaiLieuXoa": idsTaiLieuXoa
        };
        setData(saveData);
        setOpenModalLuu(true)
    };

    const submitLuu = async (value: any) => {
        try {
            dispatch(showLoadingScreen());
            const id = await luuDangKyDaoTaoNam(value);
            setOpenModalLuu(false);
            dispatch(showLoadingScreen());
            toast.success(id > 0 ? 'Cập nhật Đăng ký nhu cầu đào tạo thành công!' : 'Tạo mới Đăng ký nhu cầu đào tạo thành công!');
            dispatch(hideLoadingScreen());
            navigate(Links.DangKyDaoTao.Xem + "?id=" + id);
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
            setOpenModalLuu(false);
            toast.error(error.message || "Vui lòng thử lại");
        };
    };
    const layDuLieuPhoCVP = async () => {
        try {
            let rs = await layPhoCVPDuyetTongHopDaoTao();
            setPhoCVP(rs);
        }
        catch (error: any) {
        };
    }
    const layDuLieuPhoGiamDoc = async () => {
        try {
            let rs = await layPhoGiamDocDuyetTongHopDaoTao();

            setPhoGD(rs);
        }
        catch (error: any) {
        };
    }
    const layDuLieuChanhVP = async () => {
        try {
            let rs = await layChanhVPDuyetTongHopDaoTao();
            setChanhVP(rs);
        }
        catch (error: any) {
        };
    }
    const layDuLieuGiamDoc = async () => {
        try {
            let rs = await layGiamDocDuyetTongHopDaoTao();
            setGiamDoc(rs);
        }
        catch (error: any) {
        };
    }
    const layDuLieu = async (idData: number) => {
        try {
            let rs = await layChiTietDangKyDaoTaoNam(idData);
            setData(rs);
            form.setFieldsValue({
                "ten": rs?.ten,
                "nam": dayjs(dateCommon.formatDate(rs?.nam), "DD/MM/YYYY"),
                "ngayBatDau": dayjs(dateCommon.formatDate(rs?.ngayBatDau), "DD/MM/YYYY"),
                "ngayKetThuc": dayjs(dateCommon.formatDate(rs?.ngayKetThuc), "DD/MM/YYYY"),
                "kinhPhiDuPhong": rs?.kinhPhiDuPhong,
            });
            setTrangThai(rs.trangThai);
            if (rs.idPhoCVP > 0) {
                setIsTrinhPhoCVP(true);
                setPhoCVP({
                    "id": rs.idPhoCVP,
                    "hoTen": rs.tenPhoCVP
                });
            } else {
                layDuLieuPhoCVP();
            } 
            if (rs.idPhoGiamDoc > 0) {
                setIsTrinhPhoGD(true);
                setPhoGD({
                    "id": rs.idPhoGiamDoc,
                    "hoTen": rs.tenPhoGiamDoc
                });
            } else {
                layDuLieuPhoGiamDoc();
            }
            if (rs.idChanhVP > 0) {
                setIsTrinhCVP(true);
                setChanhVP({
                    "id": rs.idChanhVP,
                    "hoTen": rs.tenChanhVP
                });
            } else {
                layDuLieuChanhVP();
            }
            if (rs.idGiamDoc > 0) {
                setIsTrinhGD(true);
                setGiamDoc({
                    "id": rs.idGiamDoc,
                    "hoTen": rs.tenGiamDoc
                });
            } else {
                layDuLieuGiamDoc();
            }
            var fileHienTai: any = (rs?.dsTaiLieu || []).map((item: any) => {
                return {
                    uid: item.idTaiLieu + "tailieu",
                    name: item.tenTep,
                    status: 'done',
                    url: urlAdmin + item.duongDan?.replace(/\\/g, "/"),
                };
            });
            setFileList(fileHienTai);
            setIdsTaiLieuXoa([]);
        }
        catch (error: any) {
            
        };
    }
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        var idData = params.get('id') || 0;
        
        if (idData > 0) {
            setId(idData);
            layDuLieu(idData)
        } else {
            layDuLieuPhoCVP();
            layDuLieuPhoGiamDoc();
            layDuLieuChanhVP();
            layDuLieuGiamDoc();
        }
    }, []);
    return <section>
        <ContentHeader title="Đăng ký nhu cầu đào tạo" />
        {
            openModalLuu && <ModalTextForm show={openModalLuu}
                title={id > 0 ? "Cập nhật Đăng ký nhu cầu đào tạo" : "Thêm mới Đăng ký nhu cầu đào tạo"}
                handleClose={() => setOpenModalLuu(false)}
                handleSave={() => submitLuu(data)}>
                Bạn có muốn {id > 0 ? "cập nhật" : "thêm mới"} thông tin không?
            </ModalTextForm>
        }
        <Tabs
            defaultActiveKey="1" items={[
                {
                    key: "1",
                    label: "Chi tiết đợt đăng ký",
                    children:
                        <Row>
                            <Col span="24" className="card card-body">
                                <Form
                                    layout="vertical"
                                    validateMessages={validateMessages}
                                    form={form}
                                    onFinish={onFinish}
                                    initialValues={{
                                        nam: dayjs()
                                    }}
                                >
                                    <Row gutter={12}>
                                        <Col span={24}>
                                            <Form.Item
                                                name="ten"
                                                label="Tên đợt đăng ký"
                                                rules={[{ required: true, message: 'Vui lòng nhập tên đợt đăng ký' }]}
                                            >
                                                <Input placeholder="Nhập tên đợt đăng ký đào tạo năm" />
                                            </Form.Item>
                                        </Col>
                                        <Col span="6">
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                },
                                            ]} label="Năm" name="nam">
                                                <DatePicker
                                                    changeOnBlur={true}
                                                    style={{ width: "100%" }}
                                                    format={["YYYY", "YYYY"]}
                                                    placeholder="Chọn thời gian"
                                                    picker="year" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={7}>
                                            <Form.Item
                                                name="ngayBatDau"
                                                label="Ngày bắt đầu"
                                                rules={[{ required: true }]}>
                                                <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Ngày bắt đầu" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={7}>
                                            <Form.Item
                                                name="ngayKetThuc"
                                                label="Ngày kết thúc"
                                                rules={[{ required: true }]}>
                                                <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Ngày kết thúc" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={4}>
                                            {
                                                trangThai >= 0 &&
                                                <Col span="12">
                                                    <Form.Item label="Trạng thái">
                                                        <label><TrangThaiTongHopTag value={trangThai} /></label>
                                                    </Form.Item>
                                                </Col>
                                            }
                                        </Col>

                                        <Col span={12}>
                                            <Form.Item name="kinhPhiDuPhong" label="Kinh phí dự phòng (VNĐ)">
                                                <InputNumber style={{ width: '100%' }} formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} parser={value => value!.replace(/\$\s?|(,*)/g, '')} />
                                            </Form.Item>
                                        </Col>

                                        <Col span={12}>
                                            <Form.Item label="Tài liệu đính kèm đợt đăng ký">
                                                <Upload {...uploadProps} multiple>
                                                    <Button icon={<UploadOutlined rev="" />}>Chọn file đính kèm</Button>
                                                </Upload>
                                            </Form.Item>
                                        </Col>

                                        <Col span={24} style={{ marginBottom: "10px" }}>
                                            <Space>
                                                <Checkbox
                                                    checked={isTrinhPhoCVP}
                                                    onChange={(e) => {
                                                        if (e.target.checked && phoCVP == null) {
                                                            toast.warning("Vui lòng phân chức năng Duyệt đăng ký đào tạo tổng hợp cho Phó CVP");
                                                            return;
                                                        }
                                                        setIsTrinhPhoCVP(e.target.checked)
                                                    }}
                                                >
                                                    Trình Phó Chánh Văn Phòng {phoCVP ? `(${phoCVP.hoTen})` : null}
                                                </Checkbox>

                                                <Checkbox
                                                    checked={isTrinhCVP}
                                                    onChange={(e) => {
                                                        if (e.target.checked && chanhVP == null) {
                                                            toast.warning("Vui lòng phân chức năng Duyệt đăng ký đào tạo tổng hợp cho Chánh VP");
                                                            return;
                                                        }
                                                        setIsTrinhCVP(e.target.checked)
                                                    }}
                                                    style={{ marginLeft: 16 }}
                                                >
                                                    Trình Chánh Văn Phòng {chanhVP ? `(${chanhVP.hoTen})` : null}
                                                </Checkbox>

                                                <Checkbox
                                                    checked={isTrinhPhoGD}
                                                    onChange={(e) => {
                                                        if (e.target.checked && phoGD == null) {
                                                            toast.warning("Vui lòng phân chức năng Duyệt đăng ký đào tạo tổng hợp cho Phó GĐ phụ trách Văn phòng");
                                                            return;
                                                        }
                                                        setIsTrinhPhoGD(e.target.checked);
                                                    }}
                                                    style={{ marginLeft: 16 }}
                                                >
                                                    Trình Phó Giám đốc phụ trách Văn Phòng <strong>{phoGD ? `(${phoGD.hoTen})` : null}</strong>
                                                </Checkbox>

                                                <Checkbox
                                                    checked={isTrinhGD}
                                                    onChange={(e) => {
                                                        if (e.target.checked && giamDoc == null) {
                                                            toast.warning("Vui lòng phân chức năng Duyệt đăng ký đào tạo tổng hợp cho Giám đốc");
                                                            return;
                                                        }
                                                        setIsTrinhGD(e.target.checked)
                                                    }}
                                                    style={{ marginLeft: 16 }}
                                                >
                                                    Trình Giám đốc đơn vị {giamDoc ? `(${giamDoc.hoTen})` : null}
                                                </Checkbox>
                                            </Space>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span="24">
                                            <Form.Item>
                                                <Button type="primary" className="float-right" htmlType="submit" icon=<SaveOutlined rev="" />>
                                                    Lưu
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                }]} />
    </section >
}

export default ChiTietDotDangKyDaoTao;